import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthGate } from "./components/AuthGate";
import { AutomaticRun } from "./pages/AutomaticRun";
import { Contacts } from "./pages/Contacts";
import { Dashboard } from "./pages/Dashboard";
import { IcpAuthoringRun, IcpAuthoringStart } from "./pages/IcpAuthoring";
import { IcpCreate } from "./pages/IcpCreate";
import { IcpEdit } from "./pages/IcpEdit";
import { Icps } from "./pages/Icps";
import { Login } from "./pages/Login";
import { NotFound } from "./pages/NotFound";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<AuthGate />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/automatic-run" element={<AutomaticRun />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/icps" element={<Icps />} />
          <Route path="/icps/new" element={<IcpCreate />} />
          <Route path="/icps/:name" element={<IcpEdit />} />
          <Route path="/icps/:name/improve" element={<IcpAuthoringStart />} />
          <Route path="/icps/:name/improve/:runId" element={<IcpAuthoringRun />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
